import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import ContactCta from '../components/contact-cta'
import Footer from '../components/footer'
import './strategic-corridors.css'

const StrategicCorridors = (props) => {
  return (
    <div className="strategic-corridors-container10">
      <Helmet>
        <title>
          Strategic-Corridors - only one 0603 1505 of 04.03 16:42 Copy of 25.02
          14:40 Chubby Hasty Hippopotamus
        </title>
        <meta
          property="og:title"
          content="Strategic-Corridors - only one 0603 1505 of 04.03 16:42 Copy of 25.02 14:40 Chubby Hasty Hippopotamus"
        />
        <link
          rel="canonical"
          href="https://copy-of-copy-of-0403-1642-copy-of-2502-1440-chubby-h-d8xxy3.teleporthq.site/strategic-corridors"
        />
        <meta
          property="og:url"
          content="https://copy-of-copy-of-0403-1642-copy-of-2502-1440-chubby-h-d8xxy3.teleporthq.site/strategic-corridors"
        />
      </Helmet>
      <div className="strategic-corridors-container11">
        <div className="strategic-corridors-container12">
          <Script
            html={`<style>
#info-asia {
  top: 15%;
  right: 10%;
}
#info-cis {
  top: 5%;
  left: 40%;
}
#info-southamerica {
  bottom: 25%;
  left: 5%;
}
</style>`}
          ></Script>
        </div>
      </div>
      <Navigation
        button={
          <Fragment>
            <span className="strategic-corridors-text10">Button</span>
          </Fragment>
        }
        button1={
          <Fragment>
            <span className="strategic-corridors-text11">Button</span>
          </Fragment>
        }
        rootClassName="navigationroot-class-name1"
      ></Navigation>
      <section className="strategic-hero">
        <div className="strategic-hero-background">
          <div className="strategic-hero-grid"></div>
          <div className="strategic-hero-gradient"></div>
        </div>
        <div className="strategic-hero-content">
          <div className="strategic-hero-text">
            <div className="strategic-hero-badge">
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                </g>
              </svg>
              <span>Global Trade Network</span>
            </div>
            <h1 className="strategic-hero-headline">
              Strategic Corridors: Your Gateway to Key Markets
            </h1>
            <p className="strategic-hero-subheadline">
              We don&apos;t just ship worldwide. We provide deep regional
              expertise, established logistics networks, and market intelligence
              in the world&apos;s most dynamic trade lanes.
            </p>
            <div className="strategic-hero-stats">
              <div className="strategic-stat">
                <div className="strategic-stat-number">
                  <span>3</span>
                </div>
                <div className="strategic-stat-label">
                  <span>Core Regions</span>
                </div>
              </div>
              <div className="strategic-stat-divider"></div>
              <div className="strategic-stat">
                <div className="strategic-stat-number">
                  <span>25+</span>
                </div>
                <div className="strategic-stat-label">
                  <span>Markets Served</span>
                </div>
              </div>
              <div className="strategic-stat-divider"></div>
              <div className="strategic-stat">
                <div className="strategic-stat-number">
                  <span>24/7</span>
                </div>
                <div className="strategic-stat-label">
                  <span>Support Network</span>
                </div>
              </div>
            </div>
          </div>
          <div className="strategic-hero-map-container">
            <div className="strategic-map-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 800 500"
                className="strategic-world-map"
              >
                <defs>
                  <linearGradient
                    id="mapGradient"
                    x1="0%"
                    x2="100%"
                    y1="0%"
                    y2="100%"
                  >
                    <stop
                      offset="0%"
                      className="strategic-corridors-icon106"
                    ></stop>
                    <stop
                      offset="100%"
                      className="strategic-corridors-icon107"
                    ></stop>
                  </linearGradient>
                  <filter id="glow">
                    <feGaussianBlur
                      result="coloredBlur"
                      stdDeviation="3"
                    ></feGaussianBlur>
                    <feMerge>
                      <feMergeNode in="coloredBlur"></feMergeNode>
                      <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                  </filter>
                </defs>
                <g
                  fill="url(#mapGradient)"
                  stroke="var(--color-primary)"
                  opacity="0.4"
                  strokeWidth="1.5"
                  className="map-continents"
                >
                  <path d="M100,80 L140,70 L180,85 L190,120 L170,150 L140,160 L110,145 L90,110 Z"></path>
                  <path d="M160,200 L185,195 L200,220 L195,260 L175,290 L155,280 L150,240 Z"></path>
                  <path d="M380,80 L420,75 L440,95 L425,120 L395,115 L375,100 Z"></path>
                  <path d="M370,140 L410,135 L430,160 L435,200 L420,240 L390,245 L365,210 L360,170 Z"></path>
                  <path d="M480,70 L580,65 L650,80 L680,110 L670,150 L630,170 L580,165 L540,140 L510,110 L470,95 Z"></path>
                  <path d="M620,280 L670,275 L690,300 L680,325 L640,330 L615,310 Z"></path>
                </g>
                <g
                  fill="none"
                  stroke="var(--color-accent)"
                  opacity="0.6"
                  strokeWidth="1.5"
                  className="map-connections"
                >
                  <path
                    d="M550,120 Q500,150 200,230"
                    id="connection1"
                    strokeDasharray="5,5"
                  >
                    <animate
                      to="-500"
                      dur="20s"
                      from="0"
                      repeatCount="indefinite"
                      attributeName="stroke-dashoffset"
                    ></animate>
                  </path>
                  <path
                    d="M550,120 Q450,100 380,95"
                    id="connection2"
                    strokeDasharray="5,5"
                  >
                    <animate
                      to="-300"
                      dur="15s"
                      from="0"
                      repeatCount="indefinite"
                      attributeName="stroke-dashoffset"
                    ></animate>
                  </path>
                  <path
                    d="M380,95 Q270,140 200,230"
                    id="connection3"
                    strokeDasharray="5,5"
                  >
                    <animate
                      to="-400"
                      dur="18s"
                      from="0"
                      repeatCount="indefinite"
                      attributeName="stroke-dashoffset"
                    ></animate>
                  </path>
                </g>
                <g
                  id="region-asia"
                  data-region="asia"
                  className="strategic-region"
                >
                  <circle
                    r="45"
                    cx="550"
                    cy="120"
                    fill="var(--color-accent)"
                    opacity="0.15"
                    className="region-pulse"
                  ></circle>
                  <circle
                    r="35"
                    cx="550"
                    cy="120"
                    fill="var(--color-accent)"
                    opacity="0.25"
                    className="region-pulse region-pulse-2"
                  ></circle>
                  <circle
                    r="20"
                    cx="550"
                    cy="120"
                    fill="var(--color-accent)"
                    filter="url(#glow)"
                    opacity="0.9"
                    className="region-pin"
                  ></circle>
                  <circle r="8" cx="550" cy="120" fill="#ffffff"></circle>
                  <text
                    x="550"
                    y="180"
                    fill="#ffffff"
                    fontSize="16"
                    fontWeight="600"
                    textAnchor="middle"
                    className="region-label"
                  >
                    <span>Asia-Pacific</span>
                  </text>
                </g>
                <g
                  id="region-cis"
                  data-region="cis"
                  className="strategic-region"
                >
                  <circle
                    r="45"
                    cx="450"
                    cy="90"
                    fill="#066e87"
                    opacity="0.15"
                    className="region-pulse"
                  ></circle>
                  <circle
                    r="35"
                    cx="450"
                    cy="90"
                    fill="#066e87"
                    opacity="0.25"
                    className="region-pulse region-pulse-2"
                  ></circle>
                  <circle
                    r="20"
                    cx="450"
                    cy="90"
                    fill="#066e87"
                    filter="url(#glow)"
                    opacity="0.9"
                    className="region-pin"
                  ></circle>
                  <circle r="8" cx="450" cy="90" fill="#ffffff"></circle>
                  <text
                    x="450"
                    y="150"
                    fill="#ffffff"
                    fontSize="16"
                    fontWeight="600"
                    textAnchor="middle"
                    className="region-label"
                  >
                    <span>CIS</span>
                  </text>
                </g>
                <g
                  id="region-southamerica"
                  data-region="southamerica"
                  className="strategic-region"
                >
                  <circle
                    r="45"
                    cx="180"
                    cy="240"
                    fill="#1e3a5f"
                    opacity="0.15"
                    className="region-pulse"
                  ></circle>
                  <circle
                    r="35"
                    cx="180"
                    cy="240"
                    fill="#1e3a5f"
                    opacity="0.25"
                    className="region-pulse region-pulse-2"
                  ></circle>
                  <circle
                    r="20"
                    cx="180"
                    cy="240"
                    fill="#1e3a5f"
                    filter="url(#glow)"
                    opacity="0.9"
                    className="region-pin"
                  ></circle>
                  <circle r="8" cx="180" cy="240" fill="#ffffff"></circle>
                  <text
                    x="180"
                    y="300"
                    fill="#ffffff"
                    fontSize="16"
                    fontWeight="600"
                    textAnchor="middle"
                    className="region-label"
                  >
                    <span>South America</span>
                  </text>
                </g>
              </svg>
              <div id="info-asia" className="region-info-card">
                <div className="region-info-header">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                      <circle r="3" cx="10" cy="10"></circle>
                    </g>
                  </svg>
                  <h3>Asia-Pacific</h3>
                </div>
                <p>
                  Strategic hub for manufacturing, technology, and e-commerce
                  logistics
                </p>
              </div>
              <div id="info-cis" className="region-info-card">
                <div className="region-info-header">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                      <circle r="3" cx="10" cy="10"></circle>
                    </g>
                  </svg>
                  <h3>CIS Region</h3>
                </div>
                <p>
                  Gateway to emerging markets with extensive rail and multimodal
                  networks
                </p>
              </div>
              <div id="info-southamerica" className="region-info-card">
                <div className="region-info-header">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                      <circle r="3" cx="10" cy="10"></circle>
                    </g>
                  </svg>
                  <h3>South America</h3>
                </div>
                <p>
                  Growing market with expertise in commodities and regional
                  distribution
                </p>
              </div>
            </div>
            <div className="strategic-map-legend">
              <div className="legend-item">
                <div className="strategic-corridors-thq-legend-dot-elm1 legend-dot"></div>
                <span>Active Trade Lanes</span>
              </div>
              <div className="legend-item">
                <div className="strategic-corridors-thq-legend-dot-elm2 legend-dot"></div>
                <span>Regional Hubs</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="strategic-corridors-container13">
        <div className="strategic-corridors-container14">
          <Script
            html={`<style>
        @keyframes slideInLeft {from {opacity: 0;
transform: translateX(-40px);}
to {opacity: 1;
transform: translateX(0);}}@keyframes fadeInScale {from {opacity: 0;
transform: scale(0.95);}
to {opacity: 1;
transform: scale(1);}}@keyframes pulse {0%,100% {transform: scale(1);
opacity: 0.15;}
50% {transform: scale(1.3);
opacity: 0;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="strategic-corridors-container15">
        <div className="strategic-corridors-container16">
          <Script
            html={`<script>
(function(){
  const regionElements = document.querySelectorAll(".strategic-region")
  const infoCards = document.querySelectorAll(".region-info-card")

  regionElements.forEach((region) => {
    const regionId = region.getAttribute("data-region")
    const infoCard = document.getElementById(\`info-\${regionId}\`)

    region.addEventListener("mouseenter", () => {
      // Hide all cards
      infoCards.forEach((card) => card.classList.remove("active"))

      // Show the corresponding card
      if (infoCard) {
        infoCard.classList.add("active")
      }
    })

    region.addEventListener("mouseleave", () => {
      if (infoCard) {
        setTimeout(() => {
          if (!infoCard.matches(":hover")) {
            infoCard.classList.remove("active")
          }
        }, 300)
      }
    })

    // Keep card visible when hovering over it
    if (infoCard) {
      infoCard.addEventListener("mouseleave", () => {
        infoCard.classList.remove("active")
      })
    }
  })

  // Add click functionality for mobile
  if (window.innerWidth <= 767) {
    regionElements.forEach((region) => {
      const regionId = region.getAttribute("data-region")
      const infoCard = document.getElementById(\`info-\${regionId}\`)

      region.addEventListener("click", () => {
        // Toggle active state
        const isActive = infoCard.classList.contains("active")

        // Hide all cards
        infoCards.forEach((card) => card.classList.remove("active"))

        // Show clicked card if it wasn't active
        if (!isActive && infoCard) {
          infoCard.classList.add("active")
        }
      })
    })
  }

  // Animate connection lines
  const connections = document.querySelectorAll(".map-connections path")
  connections.forEach((connection, index) => {
    connection.style.animationDelay = \`\${index * 0.5}s\`
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <div className="apac-expertise-region">
        <div className="apac-expertise-wrapper">
          <div className="apac-bg-pattern"></div>
          <div className="apac-gradient-orb-1 apac-gradient-orb"></div>
          <div className="apac-gradient-orb apac-gradient-orb-2"></div>
          <div className="apac-header-container">
            <div className="apac-region-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                </g>
              </svg>
              <span>China &amp; Southeast Asia</span>
            </div>
            <h2 className="apac-main-heading">
              Asia-Pacific: The Manufacturing &amp; Innovation Hub
            </h2>
            <div className="apac-header-accent"></div>
          </div>
          <div className="apac-content-grid">
            <div className="apac-expertise-card apac-card">
              <div className="apac-card-header">
                <div className="apac-icon-expertise apac-card-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="apac-card-title">Our Expertise</h3>
              </div>
              <div className="apac-card-content">
                <div className="apac-expertise-item">
                  <div className="apac-expertise-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                  <p>
                    Direct access to major manufacturing hubs (Guangdong,
                    Zhejiang, Shandong) and emerging suppliers in Vietnam,
                    Thailand, and Indonesia.
                  </p>
                </div>
                <div className="apac-expertise-item">
                  <div className="apac-expertise-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          x="3"
                          y="3"
                          rx="2"
                          width="18\\"
                          height="18"
                        ></rect>
                        <path d="M7 7h.01M17 7h.01M7 17h.01M17 17h.01"></path>
                      </g>
                    </svg>
                  </div>
                  <p>
                    Established operational protocols with factories and vetted
                    freight forwarders.
                  </p>
                </div>
                <div className="apac-expertise-item">
                  <div className="apac-expertise-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 15a3 3 0 1 0 6 0a3 3 0 1 0-6 0"></path>
                        <path d="M13 17.5V22l2-1.5l2 1.5v-4.5"></path>
                        <path d="M10 19H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-1 1.73M6 9h12M6 12h3m-3 3h2"></path>
                      </g>
                    </svg>
                  </div>
                  <p>
                    In-depth knowledge of export procedures, customs
                    formalities, and product certification (GB Standards, SNI).
                  </p>
                </div>
              </div>
            </div>
            <div className="apac-card apac-benefits-card">
              <div className="apac-card-header">
                <div className="apac-card-icon apac-icon-benefits">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 2v20m5-17H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="apac-card-title">Your Benefits</h3>
              </div>
              <div className="apac-card-content">
                <div className="apac-benefit-item">
                  <div className="apac-benefit-number">
                    <span>01</span>
                  </div>
                  <div className="apac-benefit-text">
                    <h4>Cost Optimization</h4>
                    <p>
                      Reduced procurement costs through supply chain
                      optimization.
                    </p>
                  </div>
                </div>
                <div className="apac-benefit-item">
                  <div className="apac-benefit-number">
                    <span>02</span>
                  </div>
                  <div className="apac-benefit-text">
                    <h4>Quality Assurance</h4>
                    <p>
                      On-site quality control capability (organization of
                      inspections).
                    </p>
                  </div>
                </div>
                <div className="apac-benefit-item">
                  <div className="apac-benefit-number">
                    <span>03</span>
                  </div>
                  <div className="apac-benefit-text">
                    <h4>Speed to Market</h4>
                    <p>
                      Faster time-to-market due to predictable clearance
                      timelines.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="apac-commodities-section">
            <div className="apac-commodities-header">
              <h3 className="apac-commodities-title">Key Commodities</h3>
              <div className="apac-commodities-line"></div>
            </div>
            <div className="apac-commodities-grid">
              <div className="apac-commodity-tag">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M10 12h4m-4 5h4M10 7h4m4 5h2m-2 6h2M18 6h2M4 12h2m-2 6h2M4 6h2"></path>
                    <rect x="6" y="2" rx="2" width="12" height="20"></rect>
                  </g>
                </svg>
                <span>Electronics</span>
              </div>
              <div className="apac-commodity-tag">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11 10.27L7 3.34m4 10.39l-4 6.93M12 22v-2m0-18v2m2 8h8m-5 8.66l-1-1.73m1-15.59l-1 1.73M2 12h2m16.66 5l-1.73-1m1.73-9l-1.73 1M3.34 17l1.73-1M3.34 7l1.73 1"></path>
                    <circle r="2" cx="12" cy="12"></circle>
                    <circle r="8" cx="12" cy="12"></circle>
                  </g>
                </svg>
                <span>Machinery</span>
              </div>
              <div className="apac-commodity-tag">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 10a4 4 0 0 1-8 0M3.103 6.034h17.794"></path>
                    <path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"></path>
                  </g>
                </svg>
                <span>Consumer Goods</span>
              </div>
              <div className="apac-commodity-tag">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73zm1 .27V12"></path>
                    <path d="M3.29 7L12 12l8.71-5M7.5 4.27l9 5.15"></path>
                  </g>
                </svg>
                <span>Textiles</span>
              </div>
              <div className="apac-commodity-tag">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Industrial Raw Materials</span>
              </div>
            </div>
          </div>
          <div className="apac-bg-image">
            <img
              alt="Industrial facility"
              src="https://images.pexels.com/photos/29698521/pexels-photo-29698521.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            />
          </div>
        </div>
      </div>
      <div className="strategic-corridors-container17">
        <div className="strategic-corridors-container18">
          <Script
            html={`<style>
        @keyframes apacIconShine {0%,100% {transform: translateX(-100%) rotate(45deg);}
50% {transform: translateX(100%) rotate(45deg);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <section className="cis-eastern-europe-region">
        <div className="cis-region-container">
          <div className="cis-background-wrapper">
            <img
              alt="Eastern Europe railway infrastructure"
              src="https://images.pexels.com/photos/8584622/pexels-photo-8584622.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="cis-background-image"
            />
            <div className="cis-background-overlay"></div>
          </div>
          <div className="cis-content-wrapper">
            <div className="cis-header-section">
              <div className="cis-region-badge">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="4" y="3" rx="2" width="16" height="16"></rect>
                    <path d="M4 11h16m-8-8v8m-4 8l-2 3m12 0l-2-3m-8-4h.01M16 15h.01"></path>
                  </g>
                </svg>
                <span>
                  Commonwealth of Independent States &amp; Eastern Europe
                </span>
              </div>
              <h2 className="cis-main-heading">
                <span>
                  {' '}
                  CIS &amp; Eastern Europe:
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="strategic-corridors-thq-cis-heading-accent-elm">
                  The Strategic Land Bridge
                </span>
              </h2>
              <div className="cis-accent-bar"></div>
            </div>
            <div className="cis-expertise-grid">
              <div className="cis-expertise-card">
                <div className="cis-card-header">
                  <div className="cis-card-icon-wrapper cis-icon-primary">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                  <h3 className="cis-card-title">Our Expertise</h3>
                </div>
                <div className="cis-card-content">
                  <ul className="cis-expertise-list">
                    <li className="cis-expertise-item">
                      <div className="cis-expertise-icon">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </div>
                      <span>
                        Deep understanding of the Eurasian Economic Union (EAEU)
                        regulations and national legislative nuances.
                      </span>
                    </li>
                    <li className="cis-expertise-item">
                      <div className="cis-expertise-icon">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect
                              x="4"
                              y="3"
                              rx="2"
                              width="16"
                              height="16"
                            ></rect>
                            <path d="M4 11h16m-8-8v8m-4 8l-2 3m12 0l-2-3m-8-4h.01M16 15h.01"></path>
                          </g>
                        </svg>
                      </div>
                      <span>
                        Robust overland and rail logistics solutions (block
                        trains, FTL trucking) with full route control.
                      </span>
                    </li>
                    <li className="cis-expertise-item">
                      <div className="cis-expertise-icon">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect
                              x="16"
                              y="16"
                              rx="1"
                              width="6"
                              height="6"
                            ></rect>
                            <rect
                              x="2"
                              y="16"
                              rx="1"
                              width="6"
                              height="6"
                            ></rect>
                            <rect
                              x="9"
                              y="2"
                              rx="1"
                              width="6"
                              height="6"
                            ></rect>
                            <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                          </g>
                        </svg>
                      </div>
                      <span>
                        Familiarity with local business practices and a network
                        of reliable regional partners.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="cis-expertise-card">
                <div className="cis-card-header">
                  <div className="cis-card-icon-wrapper cis-icon-accent">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <circle r="4" cx="9" cy="7"></circle>
                      </g>
                    </svg>
                  </div>
                  <h3 className="cis-card-title">Your Benefits</h3>
                </div>
                <div className="cis-card-content">
                  <ul className="cis-expertise-list">
                    <li className="cis-expertise-item">
                      <div className="cis-expertise-icon">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </div>
                      <span>
                        Secure sourcing of raw materials (metals, timber, grain,
                        fertilizers).
                      </span>
                    </li>
                    <li className="cis-expertise-item">
                      <div className="cis-expertise-icon">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87"></path>
                            <circle r="4" cx="9" cy="7"></circle>
                          </g>
                        </svg>
                      </div>
                      <span>
                        Access to a large consumer market with growing
                        purchasing power.
                      </span>
                    </li>
                    <li className="cis-expertise-item">
                      <div className="cis-expertise-icon">
                        <svg
                          width="20"
                          xmlns="http://www.w3.org/2000/svg"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 6v6l4 2"></path>
                            <circle r="10" cx="12" cy="12"></circle>
                          </g>
                        </svg>
                      </div>
                      <span>
                        Minimized bureaucratic delays thanks to procedural
                        foresight.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="cis-commodities-section">
              <div className="cis-commodities-header">
                <div className="cis-commodities-icon-wrapper">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73zm1 .27V12"></path>
                      <path d="M3.29 7L12 12l8.71-5M7.5 4.27l9 5.15"></path>
                    </g>
                  </svg>
                </div>
                <h4 className="cis-commodities-title">Key Commodities</h4>
              </div>
              <div className="cis-commodities-grid">
                <div className="cis-commodity-tag">
                  <svg
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M2 22L16 8M3.47 12.53L5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94m4-4L9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94m4-4L13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4"></path>
                      <path d="M11.47 17.47L13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0m4-4L17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0m4-4L21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0"></path>
                    </g>
                  </svg>
                  <span>Agricultural products</span>
                </div>
                <div className="cis-commodity-tag">
                  <svg
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M2 22L16 8M3.47 12.53L5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94m4-4L9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94m4-4L13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4"></path>
                      <path d="M11.47 17.47L13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0m4-4L17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0m4-4L21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0"></path>
                    </g>
                  </svg>
                  <span>Fertilizers</span>
                </div>
                <div className="cis-commodity-tag">
                  <svg
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m15 12l-9.373 9.373a1 1 0 0 1-3.001-3L12 9m6 6l4-4"></path>
                      <path d="m21.5 11.5l-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5"></path>
                    </g>
                  </svg>
                  <span>Metals</span>
                </div>
                <div className="cis-commodity-tag">
                  <svg
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M8 5h13m-8 7h8m-8 7h8M3 10a2 2 0 0 0 2 2h3"></path>
                      <path d="M3 5v12a2 2 0 0 0 2 2h3"></path>
                    </g>
                  </svg>
                  <span>Timber</span>
                </div>
                <div className="cis-commodity-tag">
                  <svg
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 16h.01M16 16h.01M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm5-3h.01"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Industrial equipment</span>
                </div>
                <div className="cis-commodity-tag">
                  <svg
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73zm1 .27V12"></path>
                      <path d="M3.29 7L12 12l8.71-5M7.5 4.27l9 5.15"></path>
                    </g>
                  </svg>
                  <span>Packaged goods</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="sa-regional-expertise">
        <div className="sa-regional-container">
          <div className="sa-regional-background">
            <img
              alt="South America landscape"
              src="https://images.pexels.com/photos/32419583/pexels-photo-32419583.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="sa-bg-image"
            />
            <div className="sa-bg-overlay"></div>
          </div>
          <div className="sa-regional-content">
            <div className="sa-regional-header">
              <div className="sa-region-badge">
                <div className="sa-globe-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                    </g>
                  </svg>
                </div>
                <span className="sa-region-label">
                  Brazil, Argentina, Chile, Peru
                </span>
              </div>
              <h2 className="sa-main-heading">
                South America: The Resource-Rich Frontier
              </h2>
              <div className="sa-heading-accent"></div>
            </div>
            <div className="sa-dual-column-grid">
              <div className="sa-expertise-column">
                <div className="sa-section-card sa-expertise-card">
                  <div className="sa-card-header">
                    <div className="sa-icon-expertise sa-header-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73zm1 .27V12"></path>
                          <path d="M3.29 7L12 12l8.71-5M7.5 4.27l9 5.15"></path>
                        </g>
                      </svg>
                    </div>
                    <h3 className="sa-card-title">Our Expertise</h3>
                  </div>
                  <div className="sa-expertise-list">
                    <div className="sa-expertise-item">
                      <div className="sa-item-icon">
                        <svg
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8c0 5.5-4.78 10-10 10"></path>
                            <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
                          </g>
                        </svg>
                      </div>
                      <div className="sa-item-content">
                        <h4 className="sa-item-title">Export-Driven Sectors</h4>
                        <p className="sa-item-text">
                          Specialized in agribusiness, mining, and specialty
                          foods tailored for global markets.
                        </p>
                      </div>
                    </div>
                    <div className="sa-expertise-item">
                      <div className="sa-item-icon">
                        <svg
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 15a3 3 0 1 0 6 0a3 3 0 1 0-6 0"></path>
                            <path d="M13 17.5V22l2-1.5l2 1.5v-4.5"></path>
                            <path d="M10 19H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-1 1.73M6 9h12M6 12h3m-3 3h2"></path>
                          </g>
                        </svg>
                      </div>
                      <div className="sa-item-content">
                        <h4 className="sa-item-title">Complex Documentation</h4>
                        <p className="sa-item-text">
                          Expert handling of sanitary, phytosanitary, and origin
                          certificates with regulatory compliance.
                        </p>
                      </div>
                    </div>
                    <div className="sa-expertise-item">
                      <div className="sa-item-icon">
                        <svg
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <g
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 10.189V14m0-12v3m7 8V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"></path>
                            <path d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"></path>
                            <path d="M2 21c.6.5 1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1"></path>
                          </g>
                        </svg>
                      </div>
                      <div className="sa-item-content">
                        <h4 className="sa-item-title">
                          Established Port Networks
                        </h4>
                        <p className="sa-item-text">
                          Strong relationships in Santos, Buenos Aires, and
                          Valparaíso for seamless logistics.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sa-benefits-column">
                <div className="sa-benefits-card sa-section-card">
                  <div className="sa-card-header">
                    <div className="sa-icon-benefits sa-header-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M16 7h6v6"></path>
                          <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                        </g>
                      </svg>
                    </div>
                    <h3 className="sa-card-title">Your Benefits</h3>
                  </div>
                  <div className="sa-benefits-list">
                    <div className="sa-benefit-item">
                      <div className="sa-benefit-number">
                        <span>01</span>
                      </div>
                      <div className="sa-benefit-content">
                        <h4 className="sa-benefit-title">
                          Unique Commodity Access
                        </h4>
                        <p className="sa-benefit-text">
                          Direct access to premium coffee, soybeans, specialty
                          fruits (berries, avocados), copper, and lithium.
                        </p>
                      </div>
                    </div>
                    <div className="sa-benefit-item">
                      <div className="sa-benefit-number">
                        <span>02</span>
                      </div>
                      <div className="sa-benefit-content">
                        <h4 className="sa-benefit-title">
                          Supply Chain Diversification
                        </h4>
                        <p className="sa-benefit-text">
                          Reduce dependency on single-source suppliers and
                          mitigate geopolitical and market risks.
                        </p>
                      </div>
                    </div>
                    <div className="sa-benefit-item">
                      <div className="sa-benefit-number">
                        <span>03</span>
                      </div>
                      <div className="sa-benefit-content">
                        <h4 className="sa-benefit-title">
                          Competitive Sourcing Edge
                        </h4>
                        <p className="sa-benefit-text">
                          Gain market advantage with high-demand specialty
                          products and strategic commodity positioning.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sa-commodities-section">
              <div className="sa-commodities-header">
                <div className="sa-commodities-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="sa-commodities-title">Key Commodities</h3>
              </div>
              <div className="sa-commodities-grid">
                <div className="sa-commodity-tag">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M10 2v2m4-2v2m2 4a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1M6 2v2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Coffee</span>
                </div>
                <div className="sa-commodity-tag">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M2 22L16 8M3.47 12.53L5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94m4-4L9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94m4-4L13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4"></path>
                      <path d="M11.47 17.47L13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0m4-4L17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0m4-4L21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0"></path>
                    </g>
                  </svg>
                  <span>Soybeans</span>
                </div>
                <div className="sa-commodity-tag">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 6.528V3a1 1 0 0 1 1-1h0"></path>
                      <path d="M18.237 21A15 15 0 0 0 22 11a6 6 0 0 0-10-4.472A6 6 0 0 0 2 11a15.1 15.1 0 0 0 3.763 10a3 3 0 0 0 3.648.648a5.5 5.5 0 0 1 5.178 0A3 3 0 0 0 18.237 21"></path>
                    </g>
                  </svg>
                  <span>Fresh &amp; Frozen Fruits</span>
                </div>
                <div className="sa-commodity-tag">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8c0 5.5-4.78 10-10 10"></path>
                      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
                    </g>
                  </svg>
                  <span>Beef</span>
                </div>
                <div className="sa-commodity-tag">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                    </g>
                  </svg>
                  <span>Copper Concentrate</span>
                </div>
                <div className="sa-commodity-tag">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="10" cx="12" cy="12"></circle>
                      <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                    </g>
                  </svg>
                  <span>Lithium Carbonate</span>
                </div>
                <div className="sa-commodity-tag">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 6.528V3a1 1 0 0 1 1-1h0"></path>
                      <path d="M18.237 21A15 15 0 0 0 22 11a6 6 0 0 0-10-4.472A6 6 0 0 0 2 11a15.1 15.1 0 0 0 3.763 10a3 3 0 0 0 3.648.648a5.5 5.5 0 0 1 5.178 0A3 3 0 0 0 18.237 21"></path>
                    </g>
                  </svg>
                  <span>Wine</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="corridors-closing-section">
        <div className="closing-background-wrapper">
          <img
            alt="Global network connections"
            src="https://images.pexels.com/photos/7236028/pexels-photo-7236028.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="closing-bg-image"
          />
          <div className="closing-gradient-overlay"></div>
        </div>
        <div className="closing-content-container">
          <div className="closing-geometric-accent"></div>
          <div className="closing-icon-group">
            <div className="closing-icon-circle">
              <svg
                width="32"
                xmlns="http://www.w3.org/2000/svg"
                height="32"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                </g>
              </svg>
            </div>
            <div className="closing-icon-circle-delay-1 closing-icon-circle">
              <svg
                width="32"
                xmlns="http://www.w3.org/2000/svg"
                height="32"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                  <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                  <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                  <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                </g>
              </svg>
            </div>
          </div>
          <div className="closing-main-content">
            <div className="closing-header-wrapper">
              <div className="closing-accent-bar"></div>
              <h2 className="closing-headline">
                Your Next Market is Within Reach
              </h2>
            </div>
            <p className="closing-summary-text">
              Our focused expertise in these core corridors is your strategic
              advantage. It allows us to ensure reliability where it matters
              most. Yet, supported by our global partner network, we retain the
              flexibility to build efficient supply chains from any origin to
              any destination.
            </p>
            <div className="closing-cta-wrapper">
              <a
                href="#ContactCta"
                id="contactSpecialistBtn"
                className="strategic-corridors-thq-closing-cta-button-elm closing-cta-button"
              >
                <span className="strategic-corridors-thq-closing-cta-text-elm">
                  Contact Your Trade Specialist
                </span>
                <span className="strategic-corridors-thq-closing-cta-icon-elm">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m5 12l7-7l7 7m-7 7V5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </span>
              </a>
              <div className="closing-cta-underline"></div>
            </div>
          </div>
          <div className="closing-decorative-dots">
            <span className="closing-dot"></span>
            <span className="closing-dot"></span>
            <span className="closing-dot"></span>
            <span className="closing-dot"></span>
            <span className="closing-dot"></span>
            <span className="closing-dot"></span>
          </div>
        </div>
        <div className="closing-bottom-accent"></div>
      </section>
      <div className="strategic-corridors-container19">
        <div className="strategic-corridors-container20">
          <Script
            html={`<style>
        @keyframes closing-float {0%,100% {transform: translateY(0) scale(1);}
50% {transform: translateY(-30px) scale(1.1);}}@keyframes closing-icon-pulse {0%,100% {transform: scale(1);
box-shadow: 0 8px 32px color-mix(in oklab, var(--color-primary) 40%, transparent);}
50% {transform: scale(1.08);
box-shadow: 0 12px 48px color-mix(in oklab, var(--color-accent) 50%, transparent);}}@keyframes closing-dot-pulse {0%,100% {opacity: 0.3;
transform: scale(1);}
50% {opacity: 1;
transform: scale(1.3);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="strategic-corridors-container21">
        <div className="strategic-corridors-container22">
          <Script
            html={`<script>
(function(){
  const contactBtn = document.getElementById("contactSpecialistBtn")

  if (contactBtn) {
    contactBtn.addEventListener("click", function () {
      // Add your contact form logic, modal trigger, or navigation here
      console.log("Contact specialist button clicked")
      // Example: window.location.href = '/contact';
      // Example: openContactModal();
    })

    // Add ripple effect on click
    contactBtn.addEventListener("click", function (e) {
      const ripple = document.createElement("span")
      const rect = this.getBoundingClientRect()
      const size = Math.max(rect.width, rect.height)
      const x = e.clientX - rect.left - size / 2
      const y = e.clientY - rect.top - size / 2

      ripple.style.width = ripple.style.height = size + "px"
      ripple.style.left = x + "px"
      ripple.style.top = y + "px"
      ripple.style.position = "absolute"
      ripple.style.borderRadius = "50%"
      ripple.style.background = "rgba(255, 255, 255, 0.6)"
      ripple.style.transform = "scale(0)"
      ripple.style.animation = "ripple-effect 0.6s ease-out"
      ripple.style.pointerEvents = "none"

      this.appendChild(ripple)

      setTimeout(() => ripple.remove(), 600)
    })
  }

  // Add ripple animation
  const style = document.createElement("style")
  style.textContent = \`
  @keyframes ripple-effect {
    to {
      transform: scale(2.5);
      opacity: 0;
    }
  }
\`
  document.head.appendChild(style)
})()
</script>`}
          ></Script>
        </div>
      </div>
      <div className="strategic-corridors-container23">
        <div className="strategic-corridors-container24">
          <Script
            html={`<style>
#info-asia {
  top: 15%;
  right: 10%;
}
#info-cis {
  top: 5%;
  left: 40%;
}
#info-southamerica {
  bottom: 25%;
  left: 5%;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="strategic-corridors-container25">
        <div className="strategic-corridors-container26">
          <Script
            html={`<style>
        @keyframes slideInLeft {from {opacity: 0;
transform: translateX(-40px);}
to {opacity: 1;
transform: translateX(0);}}@keyframes fadeInScale {from {opacity: 0;
transform: scale(0.95);}
to {opacity: 1;
transform: scale(1);}}@keyframes pulse {0%,100% {transform: scale(1);
opacity: 0.15;}
50% {transform: scale(1.3);
opacity: 0;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="strategic-corridors-container27">
        <div className="strategic-corridors-container28">
          <Script
            html={`<script>
(function(){
  const regionElements = document.querySelectorAll(".strategic-region")
  const infoCards = document.querySelectorAll(".region-info-card")

  regionElements.forEach((region) => {
    const regionId = region.getAttribute("data-region")
    const infoCard = document.getElementById(\`info-\${regionId}\`)

    region.addEventListener("mouseenter", () => {
      // Hide all cards
      infoCards.forEach((card) => card.classList.remove("active"))

      // Show the corresponding card
      if (infoCard) {
        infoCard.classList.add("active")
      }
    })

    region.addEventListener("mouseleave", () => {
      if (infoCard) {
        setTimeout(() => {
          if (!infoCard.matches(":hover")) {
            infoCard.classList.remove("active")
          }
        }, 300)
      }
    })

    // Keep card visible when hovering over it
    if (infoCard) {
      infoCard.addEventListener("mouseleave", () => {
        infoCard.classList.remove("active")
      })
    }
  })

  // Add click functionality for mobile
  if (window.innerWidth <= 767) {
    regionElements.forEach((region) => {
      const regionId = region.getAttribute("data-region")
      const infoCard = document.getElementById(\`info-\${regionId}\`)

      region.addEventListener("click", () => {
        // Toggle active state
        const isActive = infoCard.classList.contains("active")

        // Hide all cards
        infoCards.forEach((card) => card.classList.remove("active"))

        // Show clicked card if it wasn't active
        if (!isActive && infoCard) {
          infoCard.classList.add("active")
        }
      })
    })
  }

  // Animate connection lines
  const connections = document.querySelectorAll(".map-connections path")
  connections.forEach((connection, index) => {
    connection.style.animationDelay = \`\${index * 0.5}s\`
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <ContactCta
        btn={
          <Fragment>
            <span className="strategic-corridors-text72">
              Request My Solution
            </span>
          </Fragment>
        }
        text={
          <Fragment>
            <span className="strategic-corridors-text73">
              15+ Years Expertise
            </span>
          </Fragment>
        }
        sectionTitle={
          <Fragment>
            <span className="strategic-corridors-text74">
              Get Your Personalized Solution
            </span>
          </Fragment>
        }
        rootClassName="contact-ctaroot-class-name2"
        sectionContent={
          <Fragment>
            <span className="strategic-corridors-text75">
              Connect with our Dedicated Trade Specialists to request a tailored
              End-to-End Solution for your business.
            </span>
          </Fragment>
        }
      ></ContactCta>
      <Footer rootClassName="footerroot-class-name"></Footer>
    </div>
  )
}

export default StrategicCorridors
